const apiErrors = {
  generic: "Eitthvað fór úrskeiðis. Vinsamlegast reyndu aftur.",

  INVALID_REQUEST_BODY: "Ekki tókst að lesa beiðnina. Vinsamlegast reyndu aftur.",
  ALL_FIELDS_REQUIRED: "Netfang, nafn, stofnun og lykilorð eru öll nauðsynleg.",
  INVALID_EMAIL_FORMAT: "Vinsamlegast sláðu inn gilt netfang.",
  EMAIL_DOMAIN_NOT_ALLOWED: "Þetta netfangasvæði er ekki leyfilegt. Vinsamlegast notaðu netfang frá þinni stofnun.",
  PI_EMAIL_REQUIRED: "Netfang verkefnisstjóra (PI) er nauðsynlegt til að skrá sig án boðs.",
  REGISTRATION_BY_INVITE_ONLY:
    "Skráning er eingöngu með boði. Vinsamlegast notaðu boðstengilinn frá verkefnisstjóra þínum, eða hafðu samband við hann til að fá boð.",
  USER_EXISTS_LOGIN_REDIRECT:
    "Notandi með þetta netfang er þegar til. Vinsamlegast skráðu þig inn og óskaðu eftir aðgangi að verkefni á stjórnborðinu þínu.",
  USER_EXISTS_ACTIVE_INVITE:
    "Notandi með þetta netfang er þegar til og er virkur. Vinsamlegast skráðu þig inn og óskaðu eftir aðgangi að verkefni á stjórnborðinu þínu.",
  USER_ALREADY_EXISTS: "Notandi með þetta netfang er þegar til.",
  CREATE_USER_FAILED: "Ekki tókst að stofna aðganginn þinn. Vinsamlegast reyndu aftur.",
  INVITATION_INVALID: "Þessi boðstengill er ógildur eða útrunninn.",
  INVITATION_FOR_EMAIL_ONLY: "Þetta boð gildir eingöngu fyrir {{email}}.",
  INVITATION_PROCESSING_FAILED: "Ekki tókst að vinna úr þessu boði. Vinsamlegast reyndu aftur.",
  REGISTRATION_FAILED: "Ekki tókst að ljúka skráningu. Vinsamlegast reyndu aftur.",
  ASSIGN_USER_TO_PROJECT_FAILED: "Ekki tókst að bæta þér við verkefnið. Vinsamlegast reyndu aftur.",

  LOGIN_RATE_LIMITED:
    "Of margar misheppnaðar innskráningartilraunir. Vinsamlegast reyndu aftur eftir {{retryAfterSeconds}} sekúndur.",
  INVALID_CREDENTIALS: "Rangt netfang eða lykilorð.",
  USER_NOT_INVITED:
    "Þessi aðgangur er ekki til í kerfinu. Aðgangur krefst boðs — vinsamlegast hafðu samband við verkefnisstjóra þinn.",
  SESSION_CREATE_FAILED: "Ekki tókst að hefja innskráningarlotu. Vinsamlegast reyndu aftur.",
  INVALID_2FA_TOKEN: "Ógildur tvíþátta kóði.",
  REFRESH_TOKEN_REQUIRED: "Endurnýjunartóku vantar.",
  REFRESH_TOKEN_INVALID: "Innskráningarlotan þín er ógild eða útrunnin. Vinsamlegast skráðu þig inn aftur.",
  AUTHENTICATION_REQUIRED: "Vinsamlegast skráðu þig inn til að halda áfram.",
  LOGOUT_FAILED: "Ekki tókst að skrá þig út. Vinsamlegast reyndu aftur.",
  EMAIL_CODE_REQUIRED: "Netfang og staðfestingarkóði eru nauðsynleg.",
  EMAIL_REQUIRED: "Netfang er nauðsynlegt.",
  VERIFICATION_SEND_FAILED: "Ekki tókst að senda staðfestingarkóðann. Vinsamlegast reyndu aftur.",
  PASSWORD_RESET_RATE_LIMITED:
    "Of margar beiðnir um endurstillingu lykilorðs. Vinsamlegast reyndu aftur eftir {{resetTime}}.",
  RESET_TOKEN_REQUIRED: "Endurstillingartóku og nýtt lykilorð vantar.",
  CURRENT_NEW_PASSWORD_REQUIRED: "Núverandi lykilorð og nýtt lykilorð eru nauðsynleg.",
  "2FA_TOKEN_REQUIRED": "Tvíþátta kóði er nauðsynlegur.",
  EMAIL_CODE_EXPIRED: "Þessi staðfestingarkóði er útrunninn. Vinsamlegast óskaðu eftir nýjum.",
  EMAIL_CODE_TOO_MANY_ATTEMPTS: "Of margar misheppnaðar tilraunir. Vinsamlegast óskaðu eftir nýjum staðfestingarkóða.",
  EMAIL_CODE_INVALID: "Ógildur staðfestingarkóði.",
  EMAIL_CODE_NOT_FOUND: "Enginn staðfestingarkóði fannst fyrir þetta netfang. Vinsamlegast óskaðu eftir nýjum.",
  RESET_TOKEN_INVALID: "Þessi tengill til að endurstilla lykilorð er ógildur.",
  RESET_TOKEN_USED: "Þessi tengill til að endurstilla lykilorð hefur þegar verið notaður.",
  RESET_TOKEN_EXPIRED: "Þessi tengill til að endurstilla lykilorð er útrunninn. Vinsamlegast óskaðu eftir nýjum.",
  PASSWORD_REUSED: "Þetta lykilorð hefur verið notað nýlega. Vinsamlegast veldu annað lykilorð.",
  CURRENT_PASSWORD_INCORRECT: "Núverandi lykilorð er rangt.",
  NEW_PASSWORD_SAME_AS_OLD: "Nýja lykilorðið verður að vera frábrugðið núverandi lykilorði.",
  USER_NOT_FOUND: "Notandi fannst ekki.",

  "2FA_STATUS_FAILED": "Ekki tókst að sækja stöðu tvíþátta auðkenningar. Vinsamlegast reyndu aftur.",
  INVALID_PASSWORD: "Rangt lykilorð.",
  "2FA_PASSWORD_REQUIRED": "Vinsamlegast sláðu inn lykilorðið þitt til að setja upp tvíþátta auðkenningu.",
  "2FA_SESSION_EXPIRED": "Innskráningarlotan þín er útrunnin. Vinsamlegast sláðu inn lykilorðið þitt til að halda áfram.",
  "2FA_SECRET_GENERATION_FAILED": "Ekki tókst að búa til uppsetningarkóða fyrir tvíþátta auðkenningu. Vinsamlegast reyndu aftur.",
  "2FA_SECRET_TOKEN_REQUIRED": "Uppsetningarkóði og tvíþátta kóði eru nauðsynleg.",
  USER_NOT_FOUND_IN_CONTEXT: "Ekki tókst að staðfesta innskráningarlotuna þína. Vinsamlegast skráðu þig inn aftur.",

  PROJECT_ARCHIVED:
    "Þetta verkefni er geymt og einungis til lestrar. Verkefnisstjóri eða stjórnandi stofnunar þarf að endurvirkja það (Stillingar verkefnis → Verkefnisstýringar) áður en hægt er að breyta nokkru í því.",
  PROJECT_STATE_VERIFY_FAILED: "Ekki tókst að staðfesta stöðu verkefnisins. Vinsamlegast reyndu aftur.",
  PROJECT_MANAGE_ACCESS_REQUIRED: "Þú hefur ekki stjórnunarréttindi á þessu verkefni.",

  MANAGER_CANNOT_CREATE_REQUEST: "Hlutverkið „stjórnandi“ getur ekki stofnað gagnabeiðnir.",
  PROJECT_ID_REQUIRED: "Verkefni er nauðsynlegt.",
  PROJECT_ACCESS_CHECK_FAILED: "Ekki tókst að staðfesta aðgang þinn að verkefninu. Vinsamlegast reyndu aftur.",
  ACCESS_DENIED_TO_PROJECT: "Þú hefur ekki aðgang að þessu verkefni.",
  TITLE_DESCRIPTION_REQUIRED: "Titill og lýsing eru nauðsynleg.",
  SELECTED_COLUMNS_REQUIRED: "Vinsamlegast veldu að minnsta kosti einn dálk.",
  DATASET_ACCESS_VALIDATE_FAILED: "Ekki tókst að staðfesta aðgang að þessu gagnasafni. Vinsamlegast reyndu aftur.",
  DATASET_NOT_FOUND_OR_DENIED: "Þetta gagnasafn fannst ekki, eða þú hefur ekki aðgang að því.",
  INVALID_DATASET_EXPIRY: "Gildistíminn er ekki gild dagsetning.",
  DATASET_EXPIRY_IN_PAST: "Gildistíminn verður að vera í framtíðinni.",
  SELECTED_COLUMN_INVALID: 'Dálkurinn „{{column}}" er ekki til í þessu gagnasafni.',
  CREATE_DATA_REQUEST_FAILED: "Ekki tókst að stofna gagnabeiðnina þína. Vinsamlegast reyndu aftur.",
  LIST_DATA_REQUESTS_FAILED: "Ekki tókst að sækja gagnabeiðnirnar þínar. Vinsamlegast reyndu aftur.",
  INVALID_REQUEST_ID: "Ógilt auðkenni beiðnar.",
  DATA_REQUEST_NOT_FOUND: "Þessi gagnabeiðni fannst ekki.",
  GET_DATA_REQUEST_FAILED: "Ekki tókst að sækja þessa gagnabeiðni. Vinsamlegast reyndu aftur.",
  VERIFY_ACCESS_FAILED: "Ekki tókst að staðfesta aðgang þinn. Vinsamlegast reyndu aftur.",
  ACCESS_DENIED: "Þú hefur ekki aðgang að þessu.",
  CANCEL_NOT_PENDING: "Einungis er hægt að hætta við beiðnir sem bíða afgreiðslu.",
  CANCEL_DATA_REQUEST_FAILED: "Ekki tókst að hætta við þessa gagnabeiðni. Vinsamlegast reyndu aftur.",
  EDIT_NOT_PENDING: "Einungis er hægt að breyta beiðnum sem bíða afgreiðslu.",
  NO_FIELDS_TO_UPDATE: "Engar breytingar til að vista.",
  UPDATE_DATA_REQUEST_FAILED: "Ekki tókst að uppfæra þessa gagnabeiðni. Vinsamlegast reyndu aftur.",
  MANAGER_CANNOT_COMMENT: "Hlutverkið „stjórnandi“ getur ekki skrifað athugasemdir við gagnabeiðnir.",
  COMMENT_REQUIRED: "Athugasemd er nauðsynleg.",
  COMMENTS_NOT_ALLOWED_STATUS:
    "Einungis er hægt að skrifa athugasemdir við beiðnir sem bíða afgreiðslu eða hafa verið samþykktar.",
  CREATE_COMMENT_FAILED: "Ekki tókst að senda athugasemdina þína. Vinsamlegast reyndu aftur.",
  GET_COMMENTS_FAILED: "Ekki tókst að sækja athugasemdirnar. Vinsamlegast reyndu aftur.",

  INVALID_PROJECT_ID: "Ógilt auðkenni verkefnis.",
  INVALID_INVITATION_ID: "Ógilt auðkenni boðs.",
  ROLE_REQUIRED: "Hlutverk er nauðsynlegt.",
  INVITEE_EMAIL_DOMAIN_NOT_ALLOWED:
    "Þetta netfangasvæði er ekki leyfilegt. Boðsgestir verða að nota netfang frá sinni stofnun.",
  NO_ORGANIZATION_CONTEXT: "Aðgangurinn þinn er ekki tengdur neinni stofnun.",
  INVITATION_TOKEN_REQUIRED: "Boðstóku vantar.",
  VERIFY_PERMISSIONS_FAILED: "Ekki tókst að staðfesta réttindi þín. Vinsamlegast reyndu aftur.",
  INVITATIONS_OWN_PROJECTS_ONLY: "Þú getur eingöngu skoðað boð fyrir þín eigin verkefni.",
  RETRIEVE_INVITATIONS_FAILED: "Ekki tókst að sækja boðin. Vinsamlegast reyndu aftur.",

  NOTIFICATIONS_LIST_FAILED: "Ekki tókst að sækja tilkynningarnar þínar. Vinsamlegast reyndu aftur.",
  NOTIFICATIONS_UNREAD_COUNT_FAILED: "Ekki tókst að sækja fjölda ólesinna tilkynninga. Vinsamlegast reyndu aftur.",
  NOTIFICATION_INVALID_ID: "Ógilt auðkenni tilkynningar.",
  NOTIFICATION_NOT_FOUND_OR_READ: "Þessi tilkynning fannst ekki, eða hefur þegar verið lesin.",
  NOTIFICATION_MARK_READ_FAILED: "Ekki tókst að merkja þessa tilkynningu sem lesna. Vinsamlegast reyndu aftur.",
  NOTIFICATIONS_MARK_ALL_READ_FAILED: "Ekki tókst að merkja allar tilkynningar sem lesnar. Vinsamlegast reyndu aftur.",
  NOTIFICATION_NOT_FOUND_OR_DISMISSED: "Þessi tilkynning fannst ekki, eða hefur þegar verið afgreidd.",
  NOTIFICATION_DISMISS_FAILED: "Ekki tókst að afgreiða þessa tilkynningu. Vinsamlegast reyndu aftur.",

  RETRIEVE_ACCESS_REQUESTS_FAILED: "Ekki tókst að sækja aðgangsbeiðnirnar. Vinsamlegast reyndu aftur.",

  PASSWORD_REQUIREMENTS_NOT_MET: "Lykilorðið uppfyllir ekki öryggiskröfur.",
  PASSWORD_FORBIDDEN_PATTERN: "Lykilorðið inniheldur bannað mynstur. Vinsamlegast veldu sterkara lykilorð.",
  PASSWORD_BREACHED: "Þetta lykilorð hefur komið fram í þekktum gagnaleka. Vinsamlegast veldu annað lykilorð.",
  passwordRequirementsIntro: "Lykilorðið uppfyllir ekki öryggiskröfur:",
  passwordRequirements: {
    MIN_LENGTH: "að minnsta kosti {{minLength}} stafir",
    UPPERCASE: "að minnsta kosti einn hástaf",
    LOWERCASE: "að minnsta kosti einn lágstaf",
    DIGIT: "að minnsta kosti einn tölustaf",
    SPECIAL_CHAR: "að minnsta kosti eitt sértákn ({{specialChars}})",
    AVOID_PATTERNS: "forðastu mynstur eins og: {{patterns}}",
    NOT_BREACHED: "lykilorð sem hefur ekki komið fram í þekktum gagnalekum",
  },
};

export default apiErrors;
